module.exports = __webpack_public_path__ + "static/media/carousel4.397cb75a.jpeg";